import { render, staticRenderFns } from "./DocumentCopy.vue?vue&type=template&id=00327299&scoped=true"
import script from "./DocumentCopy.vue?vue&type=script&lang=js"
export * from "./DocumentCopy.vue?vue&type=script&lang=js"
import style0 from "./DocumentCopy.vue?vue&type=style&index=0&id=00327299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00327299",
  null
  
)

export default component.exports